import React from 'react';
import { useTranslation } from 'react-i18next';
import { yesno } from '../../utils/textFormat';

const EngagementComponent = ({ report, beta }) => {
  const { t } = useTranslation();

  if (!report.engagement_type) {
    return null;
  }

  return (
    <div className="further-details">
      {beta && <div className="border-b my-4 border-[#F4F5F7]" />}
      <h2>Further Details</h2>
      <table>
        <tbody>
          <tr>
            <th>Engagement Type</th>
            <td>{t(`engagement.${report.engagement_type.toLowerCase()}`)}</td>
          </tr>
          <tr>
            <th>Person</th>
            <td>{yesno(report.engagement_subtypes.includes('person'))}</td>
          </tr>
          <tr>
            <th>Group</th>
            <td>{yesno(report.engagement_subtypes.includes('group'))}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default EngagementComponent;
